import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin, Zap } from 'lucide-react';
import { ONE_TIME_PACKAGES } from '../data/constants';

export default function BookNowPage() {
  const oneTimePackages = ONE_TIME_PACKAGES.filter(pkg => pkg.id !== 'dev_test');

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-start px-6 py-10">

      <img
        src="/images/logo.png"
        alt="Monarch Detailing"
        className="h-24 w-auto object-contain mb-6"
      />

      <div className="inline-flex items-center gap-2 bg-[#68caf1]/10 border border-[#68caf1]/30 rounded-full px-4 py-1.5 text-xs font-bold text-[#0e87b3] uppercase tracking-widest mb-4">
        <MapPin className="w-3 h-3" />
        Southern Maryland · Mobile Detailing
      </div>

      <h1 className="text-4xl md:text-5xl font-black text-[#111827] text-center leading-tight mb-2">
        Book Akeem.<br />
        <span className="text-[#68caf1]">We Come To You.</span>
      </h1>

      <div className="flex items-center gap-2 mb-10 mt-3">
        <Zap className="w-4 h-4 text-[#68caf1]" />
        <p className="text-sm text-gray-600 font-medium">Pick a package · 50% deposit holds your spot</p>
      </div>

      {/* One-Time Interior Packages — pick your package */}
      {oneTimePackages.map(pkg => (
        <Link
          key={pkg.id}
          to={`/detail/book?package=${pkg.id}`}
          className={pkg.highlight
            ? "w-full max-w-sm bg-[#68caf1] text-black rounded-2xl p-6 mb-4 flex items-center justify-between shadow-[0_4px_24px_rgba(104,202,241,0.35)] hover:bg-[#5bb8db] transition-all active:scale-[0.98]"
            : "w-full max-w-sm bg-white border-2 border-gray-200 text-black rounded-2xl p-6 mb-4 flex items-center justify-between hover:border-[#68caf1] transition-all active:scale-[0.98]"}
        >
          <div>
            <p className="text-xs font-bold uppercase tracking-widest opacity-70 mb-1">One-Time Interior Package</p>
            <p className="text-xl font-black leading-none">{pkg.emoji} {pkg.name}</p>
            <p className="text-sm font-semibold mt-1 opacity-75">from ${pkg.price} · Sedan ${pkg.price} · SUV ${pkg.suvPrice} · Truck ${pkg.truckPrice}</p>
            <p className="text-xs mt-1 opacity-60">{pkg.tagline}</p>
          </div>
          <ArrowRight className="w-6 h-6 shrink-0" />
        </Link>
      ))}

      {/* Monthly Program */}
      <Link
        to="/maintenance"
        className="w-full max-w-sm bg-[#111827] text-white rounded-2xl p-6 mb-4 flex items-center justify-between hover:bg-[#1f2937] transition-all active:scale-[0.98]"
      >
        <div>
          <p className="text-xs font-bold uppercase tracking-widest opacity-60 mb-1">Monthly Program</p>
          <p className="text-xl font-black leading-none">Interior Maintenance</p>
          <p className="text-sm font-semibold mt-1 opacity-60">Reset from $200 · then $75–$85/mo</p>
        </div>
        <ArrowRight className="w-6 h-6 shrink-0 text-[#68caf1]" />
      </Link>

      {/* Interior health check */}
      <Link
        to="/interior-check"
        className="w-full max-w-sm bg-gray-50 border border-gray-200 rounded-2xl p-5 mb-10 flex items-center justify-between hover:border-[#68caf1] transition-all active:scale-[0.98]"
      >
        <div>
          <p className="font-bold text-[#111827] text-sm">Not sure what you need?</p>
          <p className="text-[#6B7280] text-xs mt-0.5">Free 5-question interior score — A through F</p>
        </div>
        <ArrowRight className="w-5 h-5 shrink-0 text-[#68caf1]" />
      </Link>

      {/* Quick contact */}
      <div className="w-full max-w-sm space-y-3 text-center">
        <p className="text-xs text-gray-400 uppercase tracking-widest font-bold">Talk to Akeem directly</p>
        <a
          href="sms:+13018859767"
          className="w-full block bg-white border-2 border-gray-200 rounded-xl py-3 px-6 font-bold text-[#111827] hover:border-[#68caf1] transition-all text-sm"
        >
          Text (301) 885-9767
        </a>
        <a
          href="tel:+13018859767"
          className="w-full block bg-white border-2 border-gray-200 rounded-xl py-3 px-6 font-bold text-[#111827] hover:border-[#68caf1] transition-all text-sm"
        >
          Call (301) 885-9767
        </a>
      </div>

      <p className="text-xs text-gray-400 mt-8 text-center">
        St. Mary's · Charles · Calvert County, MD
      </p>

    </div>
  );
}
